import EmployeeOtpForm from '../../../shared/components/employee/employee-otp-form'
import Layout from '../../../shared/components/ui/layout'
import Image from '../../../shared/assets/images/otpImage.svg'

const EmployeeOTP = () => {
  return (
    <Layout Image={Image}>
      <EmployeeOtpForm />
    </Layout>
  )
}

export default EmployeeOTP
